import * as React from 'react';

function SvgOpen(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M10.462 14.307a.77.77 0 01-.544-1.313l7.593-7.593a2.678 2.678 0 00-1.28-.325H4.692A2.695 2.695 0 002 7.77v11.538A2.695 2.695 0 004.692 22h11.539a2.695 2.695 0 002.692-2.692V7.77c0-.448-.11-.888-.324-1.28l-7.594 7.593a.764.764 0 01-.543.225z" }),
        React.createElement("path", { fill: "currentColor", d: "M21.23 2h-5.385a.77.77 0 100 1.538h3.528L17.51 5.401c.46.25.838.628 1.088 1.088l1.863-1.863v3.528a.77.77 0 001.538 0V2.769A.77.77 0 0021.23 2z" })));
}

export default SvgOpen;
